import { filter, flatMap, isArray, isEmpty, isObject, size } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import { CloseRounded } from "@mui/icons-material";
import { Box, Card } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo } from "react";
import { formatLoanName } from "../../_src_shared/utils/formatters/formatLoanName";
import { htmlStringToText } from "../../_src_shared/utils/functions/htmlStringToText";
import AgGridTableWrapper from "../../components/agGrid/AgGridTableWrapper";
import CellRendererPriority from "../../components/agGrid/cellRenderer/CellRendererPriority";
import Flx from "../../components/layout/Flx";
import { DASHBOARD_SIDEBAR_TYPES } from "../../components/sidebars/DashboardSidebar/DashboardSidebar";
import LoanConditionsTable from "../../components/tables/LoanConditionsTable";
import Txt from "../../components/typography/Txt";
import { sidebarOpen } from "../../redux/reducers/sidebarReducer";

const ActiveFinancingRequestsConditionsSection = ({ mt = 8 }) => {
  const financingRequests = useSelector((state) => state?.financingRequests);

  const dispatch = useDispatch();

  const conditions = useMemo(() => {
    return getPendingUnderwritingRequirements(financingRequests);
  }, [financingRequests]);

  const filteredLoansWithConditions = useMemo(() => {
    return financingRequests?.filter((fr) => {
      return !isEmpty(
        getPendingUnderwritingRequirements(fr?.underwritingRequirements),
      );
    });
  }, [financingRequests]);

  const hasAnyConditions = useMemo(() => size(conditions) > 0, [conditions]);
  const onRowClicked = useCallback((params, loanId) => {
    dispatch(
      sidebarOpen(DASHBOARD_SIDEBAR_TYPES.UPDATE_LOAN_CONDITION, params?.data, {
        loanId,
        conditionId: params.data._id,
      }),
    );
  }, []);
  if (!hasAnyConditions) {
    return null;
  }

  if (isEmpty(filteredLoansWithConditions)) {
    return null;
  }

  return (
    <Card
      sx={{
        p: 2.5,
        // width: "1000%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        // boxShadow: open
        boxShadow: "none",
        background: "#fdeded",
        border: `1px solid ${red[100]}`,
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        borderTop: "none",
        // boxShadow: open
        //   ? "0 15px 40px rgba(0,0,0,0.25)"
        //   : "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* <AllBorrowerConditionsTable conditions={allConditionItems} /> */}
      <Flx column g={4}>
        {filteredLoansWithConditions?.map((fr) => {
          return (
            <Flx column g={0.5}>
              <Txt bold>{fr.loanName}</Txt>
              <LoanConditionsTable
                rowData={getPendingUnderwritingRequirements(
                  fr.underwritingRequirements,
                )}
                onRowClicked={(d) => onRowClicked(d, fr?._id)}
              />
            </Flx>
          );
        })}
      </Flx>
      {/* <LoanConditionsTable rowData={conditions} onRowClicked={onRowClicked} /> */}
    </Card>
  );
};

const getPendingUnderwritingRequirements = (conditions) => {
  // if (!isObject(conditions)) return [];

  return (
    conditions?.filter(
      (req) =>
        req?.status !== "Accepted" &&
        req?.docStipStatus !== "Received - Pending Review" &&
        req?.docStipStatus !== "Accepted",
    ) || []
  );
};

export default ActiveFinancingRequestsConditionsSection;
